import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMegaphone = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M9.1875 7.78125L21.375 3.5625V19.5L9.1875 15.2812V7.78125Z",
			stroke: "white",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.625 7.78125H9.1875V15.2812H2.625V7.78125Z",
			stroke: "white",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.1875 15.2812V20.9062H8.25C7.50408 20.9062 6.78871 20.6099 6.26126 20.0825C5.73382 19.555 5.4375 18.8397 5.4375 18.0938V15.2812",
			stroke: "white",
			strokeWidth: 1.5
		})
	]
});
const ForwardRef = forwardRef(SvgMegaphone);
export default ForwardRef;
